import { Dispatch, SetStateAction } from "react";
import { useQuery } from "react-query";
import { getTDSHandleContinue } from "./gateway";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { AxiosError } from "axios";

function useGetTDSHandleContinue({
  enabled,
  merchantReference,
  setDialog3DSOpen,
  setIframeContent,
  setEnableParesPoll,
  setIsAcsChallenge,
  relatedId,
  relatedType,
}: {
  enabled: boolean;
  merchantReference: string;
  setDialog3DSOpen: Dispatch<SetStateAction<boolean>>;
  setIframeContent: Dispatch<SetStateAction<string>>;
  setEnableParesPoll: Dispatch<SetStateAction<boolean>>;
  setIsAcsChallenge: Dispatch<SetStateAction<boolean>>;
  relatedId?: string;
  relatedType?: string;
}) {
  const navigate = useNavigate();
  return useQuery({
    queryFn: () => getTDSHandleContinue(merchantReference),
    queryKey: ["getTDSHandleContinue", merchantReference],
    enabled: enabled,
    onSuccess: (data) => {
      if (data?.data?.acsFormdata) {
        setDialog3DSOpen(true);
        setIframeContent(data?.data?.acsFormdata);
        // ACS challenge shown: render it in a real iframe and poll the public tdsParesValidation
        // result, then complete the sale.
        setIsAcsChallenge(true);
        setEnableParesPoll(true);
      } else if (data?.data?.invoiceFileName) {
        navigate("/cardPayment/successPayment", {
          state: {
            invoiceFileName: data?.data?.invoiceFileName,
            approvalCode: data?.data?.approvalCode,
            relatedId: relatedId,
            relatedType: relatedType,
          },
        });
      }
    },
    onError: (data: AxiosError<string>) => {
      enqueueSnackbar(data?.response?.data, {
        variant: "error",
      });
    },
  });
}

export default useGetTDSHandleContinue;
